import React, { useState, useEffect } from 'react';
import axios from 'axios';

const axiosClient = axios.create({
	withCredentials: true,
});

const THIRTY_MINUTES_IN_MS = 1800000;

/**
 * This hook initializes the upload settings for catalog form uploads in Filestack.
 * It also will update the signature and policy every 30 minutes.
 *
 * @param {string} userId          The user ID.
 * @param {string} organizationId  The organization ID.
 * @param {string} baseSettings    The initial upload settings for the filestack.
 *
 * @returns {Array}  The filestack settings state and function to update the state.
 */
const useFilestack = (userId, organizationId, baseSettings = {}) => {

	// Initialize the upload settings for filestack file uploads
	const [filestack, setFilestack] = useState(Object.assign({}, baseSettings, {
		path: `/organizations/${organizationId}/catalog/`,
		security: {},
	}));

	// Fetch the filestack signature and policy for application form uploads (valid for 30 mins!)
	useEffect(() => {

		if (!userId || !organizationId) {
			return () => {};
		}

		const fetchUploadPolicy = () => {

			axiosClient.get(`/api/v2/organizations/${organizationId}/upload-policy?type=catalog`)
				.then((response) => setFilestack((prev) => Object.assign({}, prev, {
					security: response.data
				})))
				.catch((error) => {
					console.error(error);
				});

		};

		fetchUploadPolicy();

		const intervalId = setInterval(fetchUploadPolicy, THIRTY_MINUTES_IN_MS);

		return () => clearInterval(intervalId);

	}, [userId, organizationId]);

	return [filestack, setFilestack];

};

export default useFilestack;
